export default __webpack_public_path__ + "static/media/Laxman.31e845cb.jpeg";